import SubscriptionInfo from './SubscriptionInfo'

export default SubscriptionInfo
